import { faroCoreApiClient } from "@api/faro-core-api-client";
import { AdmProject, BaseProjectIdProps } from "@custom-types/base-types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** Fetch project data */
export const fetchProject = createAsyncThunk<
  AdmProject,
  Partial<BaseProjectIdProps>
>("project/fetchProject", async ({ projectId }) => {
  if (!projectId) {
    throw new Error("projectId is required to fetch project data");
  }

  return await faroCoreApiClient.admin.getProjectById({ projectId });
});

/**
 * Update the selected project.
 * @param projectId - The ID of the project to update.
 * @param payload - The payload containing the updated information.
 * @returns Some keys of updated project details, such as projectId and name.
 */
export const updateProject = createAsyncThunk<
  FaroCoreApiTypes.AdmUpdateProjectDetailsPayload,
  FaroCoreApiTypes.AdmUpdateProjectDetailsPayloadProps
>("project/updateProject", async ({ projectId, payload }) => {
  if (!projectId) {
    throw new Error("projectId is required to update project details");
  }

  await faroCoreApiClient.admin.updateProjectDetails({
    projectId,
    payload,
  });

  return {
    name: payload.name,
    archivingState: payload.archivingState,
    accessLevel: payload.accessLevel,
    sqft: payload.sqft,
  };
});
